import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleButton from "../../../modules/commons/SimpleButton";
import InventoryUnitTable from "../inventory/inventorystock/common/InventoryUnitTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import * as R from "ramda";
import {
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../common/mapper";
import SimpleDate from "../../../modules/SimpleDate";
import Container from "../../../modules/commons/Container";
import StockOpnameModifying from "./modals/stockOpnameModifying";
import StockOpnameResolve from "./modals/stockOpnameResolve";
import { formGroup } from "./configs/config";
import Api from "../../../Services/Api";
import { fetchSubmitProcessStockOpname } from "./service";
import M from "moment";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import {
  contructQueryParam,
  fetchDataAsync,
  getUserAccess,
} from "../../../Services/Utils";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { HttpStatus } from "../../common/Constants";

class StockOpname extends Component {
  tableConfig = [
    {
      name: "stockOpnameDate",
      label: "Tgl Stock Opname",
      options: {
        sort: false,
      },
    },
    {
      name: "stockOpnameNo",
      label: "No Stock Opname",
      options: {
        sort: false,
      },
    },
    {
      name: "stockOpnameType",
      label: "Jenis Stock Opname",
      options: {
        customBodyRender: (value) => {
          if (!value) return "-";
          if (value === "GIFT") return "Hadiah";
          if (value === "PART") return "Part";
          if (value === "OTHER_ITEM") return "Barang Lain";
          return value;
        },
        sort: false,
      },
    },
    {
      name: "dataLocation",
      label: "Lokasi",
      options: {
        customBodyRender: (value) => {
          return value ? value.nameLocation : "";
        },
        sort: false,
      },
    },
    {
      name: "dataCabang",
      label: "Cabang",
      options: {
        customBodyRender: (value) => {
          return value ? value.namaDealer : "";
        },
        sort: false,
      },
    },
    {
      name: "stockOpnameStatus",
      label: "Status",
      options: {
        customBodyRender: (value) => {
          return value ? value : "-";
        },
        sort: false,
      },
    },
  ];

  constructor(props) {
    super(props);
    this.initialSearch = {
      kodeCabang: null,
      startDate: null,
      endDate: null,
    };
    this.state = {
      loading: false,
      modifyingModalVisible: false,
      processModalVisible: false,
      deleteModalVisible: false,
      resolveModalVisible: false,
      userAccess: null,
      selectedData: null,
      selectedCabang: null,
      filterData: null,
      search: this.initialSearch,
      dataTable: [],
      dataCabang: [],
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        startDate: M(new Date()).format("DD-MM-YYYY"),
        endDate: M(new Date()).format("DD-MM-YYYY"),
      },
    }));
    await this.fetchDataCabang();
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (
      this.state.search.kodeCabang &&
      !R.equals(this.state.search.kodeCabang, prevState.search.kodeCabang)
    ) {
      this.handleRefresh();
    }
  };

  handleResetPagination = () => {
    this.setState({
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    });
  };

  handleRefresh = async () => {
    this.setState((prevState) => ({
      ...prevState,
      userAccess: getUserAccess(
        this.props.menuAccess,
        this.state.search.kodeCabang?.value
      ),
    }));
    this.handleTriggerLoading();
    await this.fetchDataStockOpname({
      ...removeNullFields(this.parseFilterData(this.state.search)),
      kodeCabang: this.state.search.kodeCabang?.value,
      limit: this.state.pagination.limit,
      page: this.state.pagination.page,
    });
    this.handleTriggerLoading();
  };

  handleModalModifyingVisibility = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index)
        ? {
            ...prevValue.dataTable[index],
            noStockOpname: prevValue.dataTable[index].stockOpnameNo,
            stockOpnameType: mapToObjectDDL(
              prevValue.dataTable[index].stockOpnameType,
              prevValue.dataTable[index].stockOpnameType
            ),
            kodeLocation: mapToObjectDDL(
              prevValue.dataTable[index].dataLocation?.nameLocation,
              prevValue.dataTable[index].dataLocation?.kodeLocation
            ),
            kodeCabang: mapToObjectDDL(
              prevValue.dataTable[index].dataCabang?.namaDealer,
              prevValue.dataTable[index].dataCabang?.kodeCabang
            ),
          }
        : null,
      selectedCabang: this.state.search.kodeCabang,
      modifyingModalVisible: !prevValue.modifyingModalVisible,
    }));
  };

  handleModalProcessVisibility = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index)
        ? {
            ...prevValue.dataTable[index],
            noStockOpname: prevValue.dataTable[index].stockOpnameNo,
            stockOpnameType: mapToObjectDDL(
              prevValue.dataTable[index].stockOpnameType,
              prevValue.dataTable[index].stockOpnameType
            ),
            kodeLocation: mapToObjectDDL(
              prevValue.dataTable[index].dataLocation?.nameLocation,
              prevValue.dataTable[index].dataLocation?.kodeLocation
            ),
            kodeCabang: mapToObjectDDL(
              prevValue.dataTable[index].dataCabang?.namaDealer,
              prevValue.dataTable[index].dataCabang?.kodeCabang
            ),
          }
        : null,
      selectedCabang: this.state.search.kodeCabang,
      processModalVisible: !prevValue.processModalVisible,
    }));
  };

  handleModalDeleteVisibility = (index) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedData: { ...prevState.dataTable[index] },
      deleteModalVisible: !prevState.deleteModalVisible,
    }));
  };

  handleModalResolveVisibility = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index)
        ? {
            ...prevValue.dataTable[index],
            noStockOpname: prevValue.dataTable[index].stockOpnameNo,
            stockOpnameType: mapToObjectDDL(
              prevValue.dataTable[index].stockOpnameType,
              prevValue.dataTable[index].stockOpnameType
            ),
            kodeLocation: mapToObjectDDL(
              prevValue.dataTable[index].dataLocation?.nameLocation,
              prevValue.dataTable[index].dataLocation?.kodeLocation
            ),
            kodeCabang: mapToObjectDDL(
              prevValue.dataTable[index].dataCabang?.namaDealer,
              prevValue.dataTable[index].dataCabang?.kodeCabang
            ),
          }
        : null,
      selectedCabang: this.state.search.kodeCabang,
      resolveModalVisible: !prevValue.resolveModalVisible,
    }));
  };

  handleSubmitModifying = async (type, reqBody) => {
    this.handleTriggerLoading();
    let res = await fetchSubmitProcessStockOpname(
      type,
      reqBody,
      this.props.setError
    );
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleRefresh();
      this.handleModalModifyingVisibility();
    }
    this.handleTriggerLoading();
  };

  handleSubmitProcess = async (type, reqBody) => {
    this.handleTriggerLoading();
    await fetchSubmitProcessStockOpname(type, reqBody, this.props.setError);
    this.handleRefresh();
    this.handleTriggerLoading();
    this.handleModalProcessVisibility();
  };

  handleSubmitDelete = async () => {
    this.handleTriggerLoading();
    await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").deleteStockOpname,
      menuName: "Stock Opname",
      setError: this.props.setError,
      args: contructQueryParam({
        stockOpnameNo: this.state.selectedData.stockOpnameNo,
      }),
    });
    this.handleRefresh();
    this.handleModalDeleteVisibility();
    this.handleTriggerLoading();
  };

  handleOnSubmitSearch = async () => {
    this.handleTriggerLoading()
    await this.fetchDataStockOpname({
      ...removeNullFields(this.parseFilterData(this.state.search)),
      limit: this.state.pagination.limit,
      page: 1,
    });
    this.handleTriggerLoading()
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: value,
      },
    }));
  };

  handleInputDateChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: M(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleClearSearch = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: this.initialSearch,
    }));
  };

  handleChangePage = async (page, limit, callback) => {
    this.handleTriggerLoading();
    this.setState(callback);
    await this.fetchDataStockOpname({
      ...removeNullFields(this.parseFilterData(this.state.search)),
      limit: limit,
      page: page,
    });
    this.handleTriggerLoading();
  };

  handleChangeRowsPerPage = async (page, limit, callback) => {
    this.handleTriggerLoading();
    this.setState(callback);
    await this.fetchDataStockOpname({
      ...removeNullFields(this.parseFilterData(this.state.search)),
      limit: limit,
      page: 1,
    });
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchDataStockOpname = async (body) => {
    let req =
      body && Object.keys(body).length > 0
        ? body
        : {
            paramFilters: {},
            page: 1,
            limit: 5,
          };
    let response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllStockOpnameByParam,
      menuName: "Stock Opname",
      setError: this.props.setError,
      args: req,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        pagination: {
          ...prevValue.pagination,
          count: response.data.totalData || 0,
          limit: req.limit,
          page: req.page,
        },
      }));
    }
  };

  fetchDataCabang = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Stock Opname",
      setError: this.props.setError,
      args: null,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
          search: {
            ...prevValue.search,
            kodeCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang
            ),
          },
        }));
      }
    }
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
    };
  }

  render() {
    return (
      <Container>
        <FlexView
          style={{ justifyContent: "space-between" }}
          className="margin-bottom-5px margin-top-5px"
        >
          <FlexView vAlignContent="center">
            <p
              className="margin-bottom-20px margin-right-5px"
              style={{ textAlign: "right" }}
            >
              Cabang:
            </p>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang)
              )}
              value={this.state.search.kodeCabang}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
          </FlexView>
          <FlexView vAlignContent="center" style={{ gap: "15px" }}>
            <SimpleDate
              id="select_date_from"
              nextdate
              date={this.state.search.startDate}
              maxDate={this.state.search.endDate}
              onChange={(value) =>
                this.handleInputDateChange("startDate", value)
              }
            />
            <p className="margin-bottom-20px" style={{ textAlign: "center" }}>
              To
            </p>
            <SimpleDate
              id="select_date_to"
              backdate
              date={this.state.search.endDate}
              minDate={this.state.search.startDate}
              onChange={(value) => this.handleInputDateChange("endDate", value)}
            />
            <SimpleButton
              className="margin-bottom-15px"
              text="Cari"
              onClick={this.handleOnSubmitSearch}
            />
          </FlexView>
        </FlexView>

        <InventoryUnitTable
          tableConfig={this.tableConfig}
          data={this.state.dataTable}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          pagination={this.state.pagination}
          actionButtons={(tableMeta) => {
            let { dataTable } = this.state;
            let status = dataTable[tableMeta.rowIndex]?.stockOpnameStatus;
            return (
              <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                {this.state.userAccess &&
                  this.state.userAccess.updateAccess && (
                    <SimpleButton
                      category="action_button"
                      disabled={status === "COMPLETED"}
                      icon={
                        <i
                          style={{ fontSize: 20, color: status === "COMPLETED" ? "#9d9d9d" : "red" }}
                          className="fa fa-lw fa-pencil-alt"
                        />
                      }
                      onClick={() =>
                        this.handleModalModifyingVisibility(tableMeta.rowIndex)
                      }
                    />
                  )}

                <SimpleButton
                  category="action_button"
                  disabled={status === "COMPLETED"}
                  icon={
                    <i
                      style={{ fontSize: 20, color: status === "COMPLETED" ? "#9d9d9d" : "red" }}
                      className="fa fa-lg fa-paper-plane"
                    />
                  }
                  onClick={() =>
                    this.handleModalProcessVisibility(tableMeta.rowIndex)
                  }
                />

                {this.state.userAccess &&
                  this.state.userAccess.deleteAccess && (
                    <SimpleButton
                      category="action_button"
                      disabled={status === "COMPLETED"}
                      icon={
                        <i
                          style={{ fontSize: 20, color: status === "COMPLETED" ? "#9d9d9d" : "red" }}
                          className="fa fa-trash"
                        />
                      }
                      onClick={() =>
                        this.handleModalDeleteVisibility(tableMeta.rowIndex)
                      }
                    />
                  )}

                {["SUBMITTED", "COMPLETED"].includes(status) && (
                  <SimpleButton
                    category="action_button"
                    icon={
                      <i
                        style={{ fontSize: 20, color: "red" }}
                        className={"fa fa-check-square"}
                      />
                    }
                    onClick={() =>
                      this.handleModalResolveVisibility(tableMeta.rowIndex)
                    }
                  />
                )}
              </FlexView>
            );
          }}
          additionalButtons={
            <>
              {this.state.userAccess && this.state.userAccess.createAccess && (
                <FlexView vAlignContent="center">
                  <SimpleButton
                    onClick={() => this.handleModalModifyingVisibility()}
                    text={"Tambah"}
                  />
                </FlexView>
              )}
            </>
          }
        />

        {this.state.modifyingModalVisible && (
          <StockOpnameModifying
            {...this.props}
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            selectedData={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            visible={this.state.modifyingModalVisible}
            onClickClose={this.handleModalModifyingVisibility}
            onSubmit={this.handleSubmitModifying}
          />
        )}

        {this.state.processModalVisible && (
          <StockOpnameModifying
            {...this.props}
            idUser={this.props.auth.user.idUser}
            isProcess={true}
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            selectedData={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            visible={this.state.processModalVisible}
            onClickClose={this.handleModalProcessVisibility}
            onSubmit={this.handleSubmitProcess}
          />
        )}

        {this.state.deleteModalVisible && (
          <SimpleAlert
            title={"Question"}
            content={"Apakah Anda Yakin?"}
            visible={this.state.deleteModalVisible}
            onClickClose={this.handleModalDeleteVisibility}
            onSubmit={this.handleSubmitDelete}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  secondary
                  className="margin-left-none"
                  type="button"
                  text="Batal"
                  onClick={() => this.handleModalDeleteVisibility()}
                />
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Iya"
                  onClick={() => this.handleSubmitDelete()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.resolveModalVisible && (
          <StockOpnameResolve
            {...this.props}
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            idUser={this.props.auth.user.idUser}
            selectedData={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            visible={this.state.resolveModalVisible}
            onRefresh={() => {
              this.handleModalResolveVisibility();
              this.handleRefresh();
            }}
            onClickClose={this.handleModalResolveVisibility}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StockOpname);
